import(/* webpackMode: "eager", webpackExports: ["TypeformLeadCapture"] */ "/vercel/path0/components/typeform-lead-capture.tsx");
